import { useEffect } from 'react';
import storage from '../../../hooks/useStorage/useStorage';
import { useNetworkContext } from '../contexts/network/network.context';

interface UseHandleLogoutWhenOfflineWithoutEncryptionKeyParams {
  logout: () => Promise<void>;
  teamId?: string;
}

export const useHandleLogoutWhenOfflineWithoutEncryptionKey = ({
  logout,
  teamId,
}: UseHandleLogoutWhenOfflineWithoutEncryptionKeyParams) => {
  const { isOnline } = useNetworkContext();

  useEffect(() => {
    if (!teamId) {
      return;
    }

    const hasKeyInStorage = !!storage.getOfflineEncryptionKey(teamId);

    if (!isOnline && !hasKeyInStorage) {
      logout();
    }
  }, [isOnline, teamId]);
};
